interface ImageViewerTimestampProps {
  createdAt?: string;
}

const ImageViewerTimestamp = ({ createdAt }: ImageViewerTimestampProps) => {
  if (!createdAt) return null;

  return (
    <span className="text-small font-medium text-primaryGray-4">
      Created at:{" "}
      {new Date(createdAt).toLocaleString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      })}
    </span>
  );
};

export default ImageViewerTimestamp;
